import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import ReactDOM from 'react-dom/client';
import '../index.css';
import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { APP_VERSION } from '../../backend/src/version';
import { EnvVars } from '../environment';

if (!EnvVars.IS_DEV_MODE) {
  datadogRum.init({
    applicationId: '6bcf045a-a54f-4524-b46d-e301f84c7894',
    clientToken: 'pub1b045385907a7e6bbb106a495b93952d',
    site: 'datadoghq.eu',
    service: 'wexler-frontend',
    env: import.meta.env.VITE_WEXLER_ENV,

    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    plugins: [reactPlugin({ router: true })],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Required for prompt to install the PWA
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}
